import { Input } from 'antd';
import type { InputProps } from 'antd';

export function shanghaiToday(): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Shanghai', year: 'numeric',
    month: '2-digit', day: '2-digit' }).format(new Date());
}

export function DateInput(props: InputProps) {
  return <Input {...props} type="date" onClick={(event) => {
    props.onClick?.(event);
    if (event.defaultPrevented || props.disabled || props.readOnly) return;
    try {
      (event.currentTarget as HTMLInputElement).showPicker?.();
    } catch {
      return;
    }
  }} />;
}